<div class="page-header">
  <ol class="breadcrumb mb-0">

    <li class="breadcrumb-item">
      <a *ngIf="titleLink; else plain" [routerLink]="titleLink">{{ title }}</a>
      <ng-template #plain>{{ title }}</ng-template>
    </li>

    <li class="breadcrumb-item active" aria-current="page">
      {{ active_item }}
    </li>
  </ol>
</div>
